import { createCn, validators } from 'cn/config'
import type { ClassValue } from 'cn'

export function cx(...classes: ClassValue[]) {
  return classes.filter(Boolean).join(' ')
}

const legacyGradientDirections = [
  'bg-gradient-to-t',
  'bg-gradient-to-tr',
  'bg-gradient-to-r',
  'bg-gradient-to-br',
  'bg-gradient-to-b',
  'bg-gradient-to-bl',
  'bg-gradient-to-l',
  'bg-gradient-to-tl',
]

const legacyOpacityGroups = {
  'bg-opacity': [{ 'bg-opacity': [validators.isAny] }],
  'border-opacity': [{ 'border-opacity': [validators.isAny] }],
  'divide-opacity': [{ 'divide-opacity': [validators.isAny] }],
  'placeholder-opacity': [{ 'placeholder-opacity': [validators.isAny] }],
  'ring-opacity': [{ 'ring-opacity': [validators.isAny] }],
  'text-opacity': [{ 'text-opacity': [validators.isAny] }],
}

// Keep Studio typography utilities in the font-size group so they do not conflict with colors.
const customCn = createCn({
  extend: {
    classGroups: {
      ...legacyOpacityGroups,
      'bg-image': legacyGradientDirections,
      'font-size': [
        'text-xxs',
        'text-xs',
        'text-sm',
        'text-base',
        'text-lg',
        'text-xl',
        'text-10',
        'text-12',
        'text-13',
        'text-14',
        'text-16',
        'text-20',
        'text-24',
        'text-30',
        'typography-10',
        'typography-10-capitals',
        'typography-11',
        'typography-12',
        'typography-12-semibold',
        'typography-13',
        'typography-14',
        'typography-15',
        'typography-16',
        'typography-16-bold',
        'typography-20',
        'typography-24-semibold',
      ],
      rounded: [
        'rounded-studio-geometry-semantic-radius-none',
        'rounded-studio-geometry-semantic-radius-2xs',
        'rounded-studio-geometry-semantic-radius-xs',
        'rounded-studio-geometry-semantic-radius-sm',
        'rounded-studio-geometry-semantic-radius-md',
        'rounded-studio-geometry-semantic-radius-lg',
        'rounded-studio-geometry-semantic-radius-xl',
        'rounded-studio-geometry-semantic-radius-2xl',
        'rounded-studio-geometry-semantic-radius-full',
      ],
    },
  },
})

export function tw(...classes: ClassValue[]) {
  return customCn(...classes)
}
